export function QuestionCardSkeleton() {
  return (
    <div
      className="rounded-2xl p-5 space-y-3"
      style={{
        background: 'var(--color-surface)',
        border: '1px solid var(--color-border)',
      }}
      aria-busy="true"
      aria-label="Loading question"
    >
      {/* Top row: category badge + difficulty */}
      <div className="flex items-center justify-between">
        <div className="skeleton h-5 w-24 rounded-full" />
        <div className="skeleton h-4 w-16 rounded" />
      </div>

      {/* Title */}
      <div className="skeleton h-5 w-full rounded" />
      <div className="skeleton h-5 w-4/5 rounded" />

      {/* Short answer */}
      <div className="skeleton h-4 w-full rounded" />
      <div className="skeleton h-4 w-3/4 rounded" />

      {/* Footer */}
      <div className="flex items-center justify-between pt-1">
        <div className="skeleton h-5 w-14 rounded-full" />
        <div className="skeleton h-5 w-10 rounded" />
      </div>
    </div>
  );
}
